import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { PersonLinesFill, LockFill } from 'react-bootstrap-icons';
import UserProfileUpdate from '../forms/UserProfileUpdate';
import ChangePassword from '../../pages/ChangePassword';
import UpdateUserProfil from './forms/UpdateUserProfil';
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AccountSetting = function AccountSetting() {
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PersonLinesFill, {
        size: 22
      }), " PARAMETRES PROFIL"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsx(UpdateUserProfil, {})
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(LockFill, {
        size: 22
      }), " Mot de passe"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(ChangePassword, {})
  }];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Tabs, {
            animated: true,
            items: items
          })
        })
      })
    })
  });
};
export default AccountSetting;